package one.healthium.content.navigation.insights

import androidx.compose.runtime.Composable
import one.healthium.insights.ui.insights.InsightsScreen

@Composable
fun InsightsContent(
    component: InsightsComponent
) {
    InsightsScreen(component)
}